<!-- Legacy Master Summary template retained for rollback.
<div class="card mt-20" style="border: none; position: relative; height: 100%;">
  <div class="card-header">
    <span class="title" style="font-size: 22px; line-height: 45px; vertical-align: middle; position: relative;">Master
      Summary</span>
    <button class="btn btn-primary-soft" style="float: right; margin: 0 10px" (click)="refresh()">
      <i class="fa fa-refresh" aria-hidden="true"></i>
      Refresh
    </button>
    <button class="btn btn-success-soft" style="float: right; margin: 0 10px"
      *ngIf="(!fetching && !nextToken && this.summary.length > 0) || (!fetching && selectedMasterAccount)"
      (click)="export()"><i class="fa fa-download" aria-hidden="true"></i>
      Download</button>
  </div>
  <div class="card-body" [ngStyle]="{display: selectedMasterAccount ? 'none' : 'block'}">
    <div style="display: flex; justify-content: flex-end; align-items: center; margin: 10px 0px;">
      <input type="text" id="monthDate" [(ngModel)]="dateRange">
    </div>
    <div style="margin: 10px 0px; padding: 10px; border-radius: 10px; box-shadow: 1px 1px 3px 1px grey;">
      <table class="table table-docs table-hover">
        <thead>
          <tr>
            <th *ngFor="let h_ of CBSPortal ? CBSSummaryHeader : summaryHeader">{{ h_.name }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td *ngFor="let h_ of CBSPortal ? CBSSummaryHeader : summaryHeader">
              <span *ngIf="!h_.click" style="font-weight: bold;"
                [innerHTML]="h_.alter ? h_.alter(sumAccount(), h_.id) : sumAccount()[h_.id]"> </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <table class="table table-docs table-hover" id="master_accounts_table">
      <thead>
        <tr>
          <th>Sl. No.</th>
          <th *ngFor="let h of CBSPortal ? CBSHeader :headers">
            {{ h.name }}
            <span *ngIf="h.sort && h.sort.sort" (click)="notifier.sortTable(h,summary)">

              <i class="fa fa-sort-amount-desc" aria-hidden="true" *ngIf="h.sort.direction == 'Des'"></i>
              <i class="fa fa-sort-amount-asc" aria-hidden="true" *ngIf="h.sort.direction == 'Asc'"></i>
            </span>

            <span *ngIf="h.filter " class="inputseach">
              <input type="text" [(ngModel)]="h.filterText" />
              <i class="fa fa-search" aria-hidden="true"></i>
            </span>
          </th>
        </tr>
      </thead>
      <tbody [ngStyle]="{'display': summary.length > 0 ? 'table-row-group' : 'none'}">
        <ng-container *ngFor="let i of summary; let j = index">
          <tr *ngIf="notifier.filterTableColums(CBSPortal ? CBSHeader :headers ,i)">
            <td>{{j + 1}}</td>
            <td *ngFor="let h of CBSPortal ? CBSHeader :headers">
              <span *ngIf="!h.click">{{h.alter ? h.alter(i, h.id) : i[h.id]}}</span>
              <span class="btn" *ngIf="h.click" (click)="callFunction(h.click, i)">{{h.alter ? h.alter(i, h.id) :
                i[h.id]}}</span>
            </td>
          </tr>
        </ng-container>
      </tbody>
      <tbody *ngIf="summary.length == 0 && !fetching">
        <tr>
          <td [attr.colspan]=" (CBSPortal ? CBSHeader :headers ).length + 1">
            <div style="text-align: center;">No Data Found</div>
          </td>
        </tr>
      </tbody>
    </table>
    <div style="text-align: center;" *ngIf="fetching">
      <img src="../assets/img/loading_2.svg" alt="loading scans" width="18" style="width: 25px; margin: 10px" />
    </div>

  </div>
  <div class="card-body" *ngIf="selectedMasterAccount">
    <div style="padding: 5px; display: flex; justify-content: flex-start; align-items: center; gap: 6px;">
      <span style="color: blue; cursor: pointer;" (click)="selectedMasterAccount = null">Master Accounts</span>
      <span>></span>
      <span>{{selectedMasterAccount.masterAccountId}}</span>
    </div>
    <!- - <div style="margin: 10px 0px; padding: 10px; border-radius: 10px; box-shadow: 1px 1px 3px 1px grey;">
      <table class="table table-docs table-hover">
        <thead>
          <tr>
            <th *ngFor="let h_ of CBSPortal ? CBSSummaryHeader : summaryHeader">{{ h_.name }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td *ngFor="let h_ of CBSPortal ? CBSSummaryHeader : summaryHeader">
              <span *ngIf="!h_.click" style="font-weight: bold;"
                [innerHTML]="h_.alter ? h_.alter(sumAccount(), h_.id) : sumAccount()[h_.id]"> </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div> - ->
    <table class="table table-docs table-hover" id="linked_data_table">
      <thead>
        <tr>
          <th>Sl. No.</th>
          <th *ngFor="let h of lidAccountsHeader">
            {{ h.name }}
            <span *ngIf="h.sort && h.sort.sort" (click)="notifier.sortTable(h,selectedMasterAccount.lids)">

              <i class="fa fa-sort-amount-desc" aria-hidden="true" *ngIf="h.sort.direction == 'Des'"></i>
              <i class="fa fa-sort-amount-asc" aria-hidden="true" *ngIf="h.sort.direction == 'Asc'"></i>
            </span>

            <span *ngIf="h.filter " class="inputseach">
              <input type="text" [(ngModel)]="h.filterText" />
              <i class="fa fa-search" aria-hidden="true"></i>
            </span>
          </th>
        </tr>
      </thead>
      <tbody [ngStyle]="{'display': selectedMasterAccount.lids.length > 0 ? 'table-row-group' : 'none'}">
        <ng-container *ngFor="let i of selectedMasterAccount.lids; let j = index">
          <tr *ngIf="notifier.filterTableColums(lidAccountsHeader ,i)">
            <td>{{j + 1}}</td>
            <td *ngFor="let h of lidAccountsHeader">
              <span *ngIf="!h.click" [innerHTML]="h.alter ? h.alter(i, h.id) : i[h.id]"></span>
              <span class="btn" *ngIf="h.click" (click)="callFunction(h.click, i)" [innerHTML]="h.alter ? h.alter(i, h.id) :
                i[h.id]"></span>
            </td>
          </tr>
        </ng-container>
      </tbody>
      <tbody *ngIf="selectedMasterAccount.lids.length == 0 && !fetching">
        <tr>
          <td [attr.colspan]="(lidAccountsHeader ).length + 1">
            <div style="text-align: center;">No Data Found</div>
          </td>
        </tr>
      </tbody>
    </table>
    <div style="text-align: center;" *ngIf="fetching">
      <img src="../assets/img/loading_2.svg" alt="loading scans" width="18" style="width: 25px; margin: 10px" />
    </div>

  </div>
</div>
-->

<div class="card">
  <h5
    class="card-header"
    style="
      display: flex;
      justify-content: flex-center;
      align-items: center;
      gap: 8px;
    "
  >
    <button class="btn btn-light" *ngIf="selectedMID" (click)="back()">
      Back
    </button>
    {{
      selectedMID
        ? selectedMID + " Report (" + selectedDate + ")"
        : "Master Summary"
    }}
  </h5>
  <div class="card-body">
    <div
      style="
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        gap: 8px;
      "
    >
      <div
        style="
          display: flex;
          justify-content: flex-start;
          align-items: flex-end;
          gap: 8px;
        "
        [ngStyle]="{ display: !selectedMID ? 'flex' : 'none' }"
      >
        <div>
          <span>Month Year:</span>
          <span>
            <input type="text" id="monthDate" class="form-control" />
          </span>
        </div>
        <div>
          <button
            class="btn btn-light"
            (click)="loadMasterAccounts()"
            style="background-color: #5864ff; color: white"
          >
            Refresh
          </button>
          <button
            class="btn btn-light"
            (click)="erpAll(this)"
            style="background-color: #5864ff; color: white"
          >
            ERP ALL
          </button>
          <button
            class="btn btn-light"
            style="background-color: #5864ff; color: white"
            (click)="triggerFIle()"
          >
            Upload
          </button>
          <input
            type="file"
            name=""
            id="fileInput"
            style="display: none"
            (change)="checkFile($event)"
            #fileInput
          />
        </div>
        <div>
          <button
            class="btn btn-light"
            style="background-color: #5864ff; color: white"
            (click)="completeExcelApi()"
          >
            Download All
          </button>
        </div>
      </div>
      <div class="flex-start" *ngIf="selectedMID && !editMode">
        <button
          class="btn btn-light"
          style="background-color: #5864ff; color: white"
          (click)="loadErp(this, selectedMID)"
        >
          ERP
        </button>
      </div>
      <div class="flex-start" *ngIf="selectedMID && !editMode">
        <button
          class="btn btn-light"
          (click)="loadChildData(this, null, selectedMID)"
          style="background-color: #5864ff; color: white"
        >
          Refresh
        </button>
      </div>
      <div
        class="flex-start"
        *ngIf="(selectedMID ? childAccountData : cfrcData).length > 0"
      >
        <button
          class="btn btn-light"
          style="background-color: #5864ff; color: white"
          (click)="export()"
          *ngIf="!editMode"
        >
          Download Excel
        </button>
        <button
          class="btn btn-light"
          style="background-color: #5864ff; color: white"
          *ngIf="selectedMID && editMode"
          (click)="saveDetails()"
        >
          Save
        </button>
        <button
          class="btn btn-light"
          style="background-color: #5864ff; color: white"
          *ngIf="selectedMID"
          (click)="edit()"
        >
          {{ editMode ? "Exit" : "Edit" }}
        </button>
      </div>
    </div>
    <div style="max-width: 100%; overflow: auto">
      <div class="table-container">
        <table class="table table-docs table-hover" id="cloudFrontData">
          <thead class="table-header">
            <tr>
              <th>S.N.</th>
              <ng-container
                *ngFor="let h of selectedMID ? child_headers : headers"
              >
                <th *ngIf="!h.conditionalShow || showConditionalElement">
                  {{ h.name }}
                  <span
                    *ngIf="h.sort && h.sort.sort"
                    (click)="notifier.sortTable(h, cfrcData)"
                  >
                    <i
                      class="fa fa-sort-amount-desc"
                      aria-hidden="true"
                      *ngIf="h.sort.direction == 'Des'"
                    ></i>
                    <i
                      class="fa fa-sort-amount-asc"
                      aria-hidden="true"
                      *ngIf="h.sort.direction == 'Asc'"
                    ></i>
                  </span>

                  <span *ngIf="h.filter" class="inputseach">
                    <input type="text" [(ngModel)]="h.filterText" />
                    <i class="fa fa-search" aria-hidden="true"></i>
                  </span>
                </th>
              </ng-container>
            </tr>
          </thead>

          <tbody
            [ngStyle]="{
              display:
                (selectedMID ? child_headers : headers).length > 0
                  ? 'table-row-group'
                  : 'none'
            }"
          >
            <ng-container
              *ngFor="
                let i of selectedMID ? childAccountData : cfrcData;
                let j = index
              "
            >
              <tr
                [ngClass]="{ hoverable: !selectedMID }"
                *ngIf="
                  notifier.filterTableColums(
                    selectedMID ? child_headers : headers,
                    i
                  )
                "
              >
                <td>{{ j + 1 }}</td>
                <ng-container
                  *ngFor="let h of selectedMID ? child_headers : headers"
                >
                  <td *ngIf="!h.conditionalShow || showConditionalElement">
                    <span
                      *ngIf="h.click"
                      class="btn"
                      (click)="callFunction(h.click, i)"
                    >
                      {{ i[h.id] }}
                    </span>
                    <div
                      *ngIf="!h.click"
                      [ngStyle]="{
                        color: h.color ? h.color(i[h.id]) : 'inherit'
                      }"
                    >
                      <span *ngIf="!h.editable || !editMode">
                        {{ h.alter ? h.alter(i, h.id) : i[h.id] }}
                      </span>
                      <span *ngIf="h.editable && editMode">
                        <input
                          type="text"
                          [(ngModel)]="i[h.id]"
                          [disabled]="h.id == 'erp' && !i['erpEdit']"
                        />
                      </span>

                      <span
                        *ngIf="
                          selectedMID && h.icon && (!h.editable || !editMode)
                        "
                      >
                        <i
                          (click)="loadErp(this, selectedMID, i['lId'])"
                          class="fa-solid fa-arrows-rotate load_icon_style"
                        ></i>
                      </span>
                    </div>
                  </td>
                </ng-container>
              </tr>
            </ng-container>
          </tbody>
          <tbody
            *ngIf="(selectedMID ? childAccountData : cfrcData).length == 0"
          >
            <tr>
              <td
                [attr.colspan]="
                  (selectedMID ? child_headers : headers).length + 1
                "
              >
                <div style="text-align: center">No Data Found</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div
  style="
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.1);
  "
  [ngStyle]="{ display: upload ? 'block' : 'none' }"
>
  <div
    style="
      position: relative;
      margin: 10px;
      gap: 10px;
      background-color: white;
      border-radius: 10px;
      padding: 75px 20px 20px 20px;
      box-shadow: 1px 1px 3px 1px grey;
      display: flex;
      flex-direction: column;
      max-height: calc(100% - 20px);
    "
  >
    <div
      style="
        position: absolute;
        top: 10px;
        right: 10px;
        padding: 10px;
        cursor: pointer;
      "
      (click)="closeUpload()"
      class="btn btn-light"
    >
      X
    </div>
    <div style="overflow: auto; flex: 1">
      <table class="table table-docs table-hover">
        <thead>
          <tr>
            <th *ngFor="let h of editableHeader">
              {{ h.name }}
            </th>
          </tr>
        </thead>

        <tbody
          [ngStyle]="{
            display: editable.length > 0 ? 'table-row-group' : 'none'
          }"
        >
          <tr *ngFor="let i of editable; let j = index">
            <td *ngFor="let h of editableHeader">
              <span
                *ngIf="h.click"
                class="btn"
                (click)="callFunction(h.click, i)"
              >
                <span [innerHTML]="i[h.id]"> </span>
              </span>
              <span *ngIf="!h.click && !h.editable">
                {{ h.alter ? h.alter(i[h.id]) : i[h.id] }}
              </span>
              <span *ngIf="!h.click && h.editable">
                <input class="form-control" type="text" [(ngModel)]="i[h.id]" />
              </span>
            </td>
          </tr>
        </tbody>
        <tbody
          [ngStyle]="{
            display: editable.length == 0 ? 'table-row-group' : 'none'
          }"
        >
          <tr>
            <td [attr.colspan]="editableHeader.length">
              <div style="text-align: center">No Data Found</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      style="
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 15px;
      "
    >
      <button
        class="btn btn-light"
        (click)="saveDetails()"
        style="background-color: #5864ff; color: white"
      >
        Save Details
      </button>
    </div>
  </div>
</div>


<div *ngIf="isModalVisible" class="modal-overlay">
  <div class="modal-content">
    <div *ngFor="let status of masterStatuses" class="service-status">
      <span>{{ status.name }} [ {{status.masterId}} ]</span>
      <div class="status-icon">
        <div *ngIf="status.isLoading" class="circle loading">
          <span class="icon">⟳</span>
        </div>
        <div *ngIf="status.isSuccess" class="circle success">
          <span class="icon">✔</span>
        </div>
        <div *ngIf="status.isError" class="circle error">
          <span class="icon">✘</span>
        </div>
      </div>
    </div>
    <button [disabled]="!allCallsCompleted" (click)="closeModal()">Close</button>
  </div>
</div>
